module.exports = __webpack_public_path__ + "img/zap-logo.7cca2160.png";